module.exports = __webpack_public_path__ + "img/glass-champagne.94499699.svg";